export default {
  searchUserCommit(state, data) {
    state.searchUser = data;
  },
}
